<div *ngIf="items">
  <p-menubar [model]="items"></p-menubar>
</div>
